const normalizeStandaloneSiteLogo = (container) => {
  container.querySelectorAll('.hero_block .site-logo').forEach((wrapper) => {
    const svg = wrapper.querySelector('svg');
    if (!svg) return;

    // The large TES wordmark in the animated hero is visual branding only.
    // Keep it out of the accessibility tree without misusing role="img".
    wrapper.removeAttribute('role');
    wrapper.removeAttribute('aria-label');
    wrapper.removeAttribute('aria-labelledby');

    svg.removeAttribute('aria-label');
    svg.removeAttribute('aria-labelledby');
    svg.removeAttribute('aria-hidden');
    svg.setAttribute('role', 'presentation');
    svg.setAttribute('focusable', 'false');
  });
};

const normalizeDecorativeFooterMedia = (container) => {
  container.querySelectorAll('picture.footer-bg[aria-hidden="true"]').forEach((picture) => {
    const image = picture.querySelector('img');

    // alt="" already makes this image decorative. Removing the redundant
    // aria-hidden avoids exposing a visually-present wrapper as hidden content.
    if (image && image.getAttribute('alt') === '') {
      picture.removeAttribute('aria-hidden');
    }
  });
};

const normalizeAmbiguousCtas = (container) => {
  container.querySelectorAll('a.theme-cta-button').forEach((link) => {
    const visibleText = (link.textContent || '').replace(/\s+/g, ' ').trim();
    if (!/^learn more$/i.test(visibleText)) return;

    const href = link.getAttribute('href') || '';
    const context = /\/services(?:\/|#|\?|$)/i.test(href)
      ? 'our services'
      : 'this section';

    link.setAttribute('aria-label', `${visibleText} about ${context}`);
  });
};

const normalizeLinkedSwiperSlides = (container) => {
  container.querySelectorAll('a.swiper-slide').forEach((slide) => {
    // Swiper's default A11y module assigns role="group" and a numeric
    // aria-label (for example "1 / 5") to slides. On an anchor this replaces
    // the useful link name with slide-position information.
    if (slide.getAttribute('role') === 'group') {
      slide.removeAttribute('role');
    }

    const label = slide.getAttribute('aria-label');
    if (label && /^\s*\d+\s*\/\s*\d+\s*$/.test(label)) {
      slide.removeAttribute('aria-label');
    }

    if (slide.getAttribute('aria-roledescription') === 'slide') {
      slide.removeAttribute('aria-roledescription');
    }
  });
};

const normalizeCookieYesNoticeActions = (container) => {
  container.querySelectorAll('.cky-notice-btn-wrapper[role="group"]').forEach((wrapper) => {
    // These are consent action buttons, not a tab interface. The role causes
    // some accessibility engines to incorrectly classify them as custom tabs.
    wrapper.removeAttribute('role');
  });
};

const runNormalization = (container = document) => {
  normalizeStandaloneSiteLogo(container);
  normalizeDecorativeFooterMedia(container);
  normalizeAmbiguousCtas(container);
  normalizeLinkedSwiperSlides(container);
  normalizeCookieYesNoticeActions(container);
};

let observerStarted = false;
let normalizationFrame = null;

const observeLateMarkup = () => {
  if (observerStarted || !document.body) return;
  observerStarted = true;

  const observer = new MutationObserver(() => {
    if (normalizationFrame !== null) return;

    normalizationFrame = window.requestAnimationFrame(() => {
      normalizationFrame = null;
      runNormalization(document);
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

export const normalizeAccessibilityMarkup = (container = document) => {
  runNormalization(container);

  if (container === document) {
    observeLateMarkup();
  }
};
